<script setup>
import { useTheme } from 'vuetify'
import ScrollToTop from '@core/components/ScrollToTop.vue'
import initCore from '@core/initCore'
import {
  initConfigStore,
  useConfigStore,
} from '@core/stores/config'
import { hexToRgb } from '@core/utils/colorConverter'
import { isLoading } from '@/utils/api' // Import global loading state
import PwaInstaller from './components/dialogs/PwaInstaller.vue'

const { global } = useTheme()

// ℹ️ Sync current theme with initial loader theme
initCore()
initConfigStore()

const configStore = useConfigStore()
// console.log('global',global)
</script>

<template>
  <!-- $api call loading -->
  <VProgressLinear height="3" style="position: fixed;z-index: 999;" v-if="isLoading" indeterminate color="primary" />

  <VLocaleProvider :rtl="configStore.isAppRTL">
    <!-- ℹ️ This is required to set the background color of active nav link based on currently active global theme's primary -->
    <VApp :style="`--v-global-theme-primary: ${hexToRgb(global.current.value.colors.primary)}`">
      <RouterView />
      <PwaInstaller />
      <ScrollToTop />
    </VApp>
  </VLocaleProvider>
</template>
